import { PsObject } from "./core/PsObject";

export default class AddRemove extends PsObject<AddRemove>{

    id: string = '';
    addressId: string = '';
    userId: string = '';


    init(
        id : string,
        addressId : string,
        userId : string,

    ) {
        this.id =id;
        this.addressId =addressId;
        this.userId =userId;

        return this;

    }

    getPrimaryKey(): string {
        return this.id;
    }

    toMap(object: AddRemove): any {
        const map = {};
        map['id'] = this.id;
        map['address_id'] = this.addressId;
        map['user_id'] = this.userId;

        return map;
    }

    toMapList(objectList: AddRemove[]) : any[] {
        const mapList : any[] = [];
        for(let i = 0; i < objectList.length; i++) {
            if(objectList[i] != null) {
                mapList.push(this.toMap(objectList[i]));
            }
        }

        return mapList;
    }

    fromMap(obj: any) {
        return new AddRemove().init(

            obj.id,
            obj.address_id,
            obj.user_id,

       );
    }   
    fromMapList(objList : any[] ) : AddRemove[] {
        const psAppInfoList : AddRemove[] = [];
        for(const obj in objList) {
            if(obj != null) {
                psAppInfoList.push(this.fromMap(obj));
            }
        }

        return psAppInfoList;
    }
    

}